//外部リンク
const links = document.querySelectorAll('a');
for (let i = 0; i < links.length; i++) {
	if (links[i].href.indexOf == 0) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}
}

//ログインPOPUP
const agree = Cookies.get('cookie-agree');
const accountLoginBtn = document.getElementById('accountLoginBtn');
const accountLoginBtnDrawer = document.getElementById('accountLoginBtnDrawer');
const privacyPanelWrapper = document.getElementById('privacyPanelWrapper');

if (agree === 'yes') {
	accountLoginBtn.href = accountLoginBtn.dataset.url;
	accountLoginBtnDrawer.href = accountLoginBtnDrawer.dataset.url;
}

const onLogin = () => {
	privacyPanelWrapper.classList.add('open');
}

const panelCloseButton = document.getElementById('panelCloseButton');
panelCloseButton.addEventListener('click', () => {
	privacyPanelWrapper.classList.remove('open');
});
privacyPanelWrapper.addEventListener('click', () => {
	privacyPanelWrapper.classList.remove('open');
});


document.getElementById('agreeButton').addEventListener('click', function () {
	Cookies.set('cookie-agree', 'yes', { expires: 90 });
});
